import type { Airflow, Dict } from '@aviata/platform-types';

export const RAIL_EQUIPMENT_CODES = new Set(['TRN', 'TRS']);

export type OfferTransportKind = 'air' | 'rail' | 'mixed';

export const isRailSegment = (
  segment: Pick<Airflow.Segment.Entity, 'equipment'> | null | undefined,
): boolean => RAIL_EQUIPMENT_CODES.has(segment?.equipment?.code ?? '');

export const isHighSpeedRail = (
  segment: Pick<Airflow.Segment.Entity, 'equipment'> | null | undefined,
): boolean => segment?.equipment?.code === 'TRS';

export const isRailStation = (
  dict: Dict.Entity | null | undefined,
  iata: string | null | undefined,
): boolean => {
  if (!dict || !iata) {
    return false;
  }
  return dict.airports?.[iata]?.type === 'rail_station';
};

type FlightLike = { segments: Pick<Airflow.Segment.Entity, 'equipment'>[] };

export const hasRailFlight = (flight: FlightLike): boolean =>
  flight.segments?.some(isRailSegment) ?? false;

export const getOfferTransportKind = (offer: {
  flights: FlightLike[];
}): OfferTransportKind => {
  const segments = offer.flights?.flatMap(f => f.segments) ?? [];
  if (segments.length === 0) {
    return 'air';
  }
  const railCount = segments.filter(isRailSegment).length;
  if (railCount === 0) {
    return 'air';
  }
  if (railCount === segments.length) {
    return 'rail';
  }
  return 'mixed';
};
